<template>
  <div class="collapse">
    <h5>客户历史消费信息</h5>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="查询" name="1">
        <el-form :inline="true" label-width="100px" class="search-form">
          <el-form-item label="姓名">
            <el-input v-model="filters.name" clearable placeholder="请输入姓名"></el-input>
          </el-form-item>
          <el-form-item label="卡号(门诊号)">
            <el-input v-model="filters.cadCode" clearable placeholder="请输入卡号"></el-input>
          </el-form-item>
          <!-- <el-form-item label="电话号码">
            <el-input v-model="filters.mobile" clearable placeholder="请输入卡号"></el-input>
          </el-form-item> -->
          <el-form-item label="病历号">
            <el-input v-model="filters.caseCode" clearable placeholder="请输入病历号"></el-input>
          </el-form-item>
          <el-form-item label="划扣项目">
            <el-select ref="mySelected" @focus="focus(3)" clearable v-model="filters.musProjectName" placeholder="选择划扣项目" filterable :filter-method="projectMatch">
              <el-option v-for="item in projectList" :key="item.id" :label="item.project" :value="item.project">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="购买项目">
            <el-select @focus="focus(3)" clearable v-model="filters.projectName" placeholder="选择购买项目" filterable :filter-method="projectMatch">
              <el-option v-for="item in projectList" :key="item.id" :label="item.project" :value="item.project">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="划扣卡号">
            <el-input v-model="filters.musCode" clearable placeholder="请输入划扣卡号"></el-input>
          </el-form-item>
          <el-form-item label="医生">
            <el-select @focus="focus(1)" :filter-method="doctorMatch" filterable remote clearable v-model="filters.doctorName" placeholder="选择医生">
              <el-option v-for="item in newList1" :key="item.id" :label="item.identityName" :value="item.identityName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="护士">
            <el-select @focus="focus(2)" :filter-method="bbMatch" filterable remote clearable v-model="filters.nurseName" placeholder="选择护士">
              <el-option v-for="item in newList2" :key="item.id" :label="item.identityName" :value="item.identityName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="送诊护士">
            <el-select @focus="focus(2)" :filter-method="bbMatch" filterable remote clearable v-model="filters.injectionNurseName" placeholder="选择护士">
              <el-option v-for="item in newList2" :key="item.id" :label="item.identityName" :value="item.identityName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="注射项目">
            <el-select @focus="focus(3)" clearable v-model="filters.injectionProjectName" placeholder="选择注射项目" filterable :filter-method="projectMatch">
              <el-option v-for="item in projectList" :key="item.id" :label="item.project" :value="item.project">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="时间">
            <el-date-picker v-model="filters.startTime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search" size="small">查询</el-button>
          </el-form-item>
        </el-form>
      </el-collapse-item>
    </el-collapse>
    <div ref="top">
      <!-- @row-click="rowTab" -->
      <el-table max-height="230" border :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" :row-class-name="tableRowClassName">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column sortable prop="earName" label="院区"></el-table-column>
        <el-table-column sortable prop="sknDate" label="日期" width="120"></el-table-column>
        <el-table-column sortable prop="sknName" label="姓名"></el-table-column>
        <el-table-column sortable prop="cadCode" label="门诊号" width="120"></el-table-column>
        <el-table-column sortable prop="flag" label="客户标签" width="120"></el-table-column>
        <el-table-column sortable prop="caseCode" label="病历号" width="120"></el-table-column>
        <el-table-column sortable prop="mobile" label="电话" width="120"></el-table-column>
        <el-table-column sortable prop="projectName" label="购买项目" width="160"></el-table-column>
        <el-table-column sortable prop="projectReplenish" label="项目补充" width="120"></el-table-column>
        <el-table-column sortable prop="musCode" label="划扣卡号" width="120"></el-table-column>
        <el-table-column sortable prop="purchaseNumber" label="疗程购买次/支"></el-table-column>
        <el-table-column sortable prop="projectAmt" label="疗程收费" width="120"></el-table-column>
        <el-table-column sortable prop="musProjectName" label="当日划扣项目" width="160"></el-table-column>
        <el-table-column sortable prop="musAmt" label="当日划扣金额"></el-table-column>
        <el-table-column sortable prop="musContent" label="划扣次数" width="120"></el-table-column>
        <!-- <el-table-column sortable prop="rnCount" label="剩余次数" width="120"></el-table-column> -->
        <el-table-column sortable prop="doctorName" label="医生"></el-table-column>
        <el-table-column sortable prop="nurseName" label="护士"></el-table-column>
        <el-table-column sortable prop="remark" label="备注" width="120"></el-table-column>
        <el-table-column sortable prop="injectionProjectName" label="注射项目名称" width="160"></el-table-column>
        <!-- <el-table-column sortable prop="injectionProjectAmt" label="项目金额"></el-table-column> -->
        <el-table-column sortable prop="injectionNurseName" label="送诊护士" width="120"></el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  props: ["tableData", "filters", 'formData'],
  computed: {
    ...mapGetters(["list1", "list2", "productOptions"]),
  },
  data() {
    return {
      activeNames: [""],
      newList1: [],
      newList2: [],
      projectList: [],
      dialogForm: false,
      childData: {},
      childInject: {},
      detailData: {
        purchaseInformation: [
          {
            projectId: "",
            project: "",
            projectName: "",
            purchaseNumber: "",
            projectAmt: "",
            projectType: "1",
            projectReplenish: "",
            purchaseRemark: '',
          },
        ],
        musInformation: [
          {
            musProjectName: "",
            musProjectId: "",
            musAmt: "",
            musContent: "",
            musCode: "",
            rnCount: "",
            remark: "",
            materialList: [
              // {
              //   materialId: '',
              //   materialSpec: '',
              //   price: '',
              //   number: '',
              //   actualUse: '',
              //   materialName: '',
              //   manufacturers: "",
              // }
            ],
          },
        ],
        injectionProject: [
          {
            injectionProjectName: "",
            injectionProjectAmt: "",
            injectionNurseName: "",
          },
        ],
      },
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page;
      this.$emit('getData', page, "check");
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes;
      this.$emit('getData', this.filters.pagination.page, "check");
    },
    testSX() {
      this.$forceUpdate();
    },
    // 表格不同行设置不同的样式
    tableRowClassName({ row, rowIndex }) {
      if (parseInt(row.purchaseNumber) < 0) {
        return "warmRed";
      }
      return "";
    },
    focus(val) {
      if (val == 1) {
        this.newList1 = this.list1;
      } else if (val == 2) {
        this.newList2 = this.list2;
      } else if (val == 3) {
        this.projectList = this.productOptions;
      } else if (val == 4) {
        this.manList = this.createByList;
      } else if (val == "lc") {
        let newArr = this.getArr(this.areaAndFloorList);
        // 给楼层对象赋值
        this.floorOptions = newArr;
      }
    },
    rowTab(row) {
      this.dialogForm = true;
      // 根据id查询详情
      let querys = {
        musId: row.musId,
        injectionId: row.injectionId,
        purchaseId: row.purchaseId,
      };
      api.request("/skn/findSknProjectInformationById", querys, (res) => {
        console.log(res.data);
        this.detailData = res.data;
      });
    },
    backDialog() {
      this.dialogForm = false;
    },
    doctorMatch(val) {
      this.newList1 = _g.paramMatch(this.list1, this.newList1, val, 'identityName')
    },
    bbMatch(val) {
      this.newList2 = _g.paramMatch(this.list2, this.newList2, val, 'identityName')
    },
    projectMatch(val) {
      this.projectList = _g.paramMatch(this.productOptions, this.projectList, val, 'project')
    },
    search() {
      //   this.filters.pagination.page = 1
      this.$emit('getData', 1, "check");
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge(
          {},
          this.$route.query,
          {
            __query: JSON.stringify(this.pagination),
          },
          {
            random: Math.random(),
          }
        ),
      });
    },
  },
};
</script>
<style scoped>
.el-table >>> .warmRed {
  color: rgb(184, 18, 18);
}

.collapse >>> .el-collapse-item__header {
  background: #fecaca !important;
  padding-left: 10px;
  font-weight: bold;
  font-size: 15px;
  height: 25px;
  line-height: 25px;
}
.collapse >>> .el-collapse-item__content {
  padding: 10px 0 !important;
}

.collapse >>> .el-form-item {
  margin-bottom: 8px !important;
}
</style>
